const mobileIcon = document.querySelector("button.hamburger#menu-toggle");
const mobileIconClose = document.querySelector("button.hamburger#menu-toggled");
const mobileMenu = document.querySelector(".mobile-header-menu");
const resultMenuChildren = [];
const valueMenuChildren = mobileMenu.querySelectorAll(
  ".menu-item-has-children"
);
Array.prototype.push.apply(resultMenuChildren, valueMenuChildren);
const dropdownMenu = resultMenuChildren;
const mobileDropdown = resultMenuChildren;
const body = document.querySelector("body");

// const main = document.querySelector("main");
// const resultSections = [];
// const valuesSections = document.querySelectorAll("section");
// Array.prototype.push.apply(resultSections, valuesSections);
// const sections = resultSections;
// const footer = document.querySelector("footer");

let mobileIconOpen = () => {
  if (mobileIcon.classList.length === 2) {
    mobileIcon.classList.toggle("initial");
  } else {
    mobileIcon.classList.toggle("initial");
  }
  mobileIcon.classList.toggle("change");
  mobileMenu.classList.toggle("d-left");
};

jQuery(
  "button.hamburger#menu-toggle, button.hamburger#menu-toggled, button#close"
).click(function () {
  // , a
  jQuery(".main-nav, header > .overlay").toggleClass("is-active");
  body.classList.remove("overflow-hidden");

  if (!mobileMenu.classList.contains("d-left")) {
    // On close, get all of the sub-menu's that are visible, close them
    // d-left is applied to mobileMenu while it is closed
    const x = mobileMenu.querySelectorAll(".expandable-mobile-menu");
    x.forEach(
      (item, i) =>
        item.classList.contains("visibled") && item.classList.toggle("visibled")
    );
  }
});

/**
 * This is to make sure when going back a page (specifically on mobile)
 * When the page is cached, the menu wont be open anymore.
 */
jQuery(".mobile-header-menu a").click(function () {
  const link = jQuery(this).attr("href");
  if (link === "javascript:void(0)") {
    link = undefined;
  }
  if (link != undefined) {
    mobileIconOpen();
  }
  jQuery(".main-nav, header > .overlay").toggleClass("is-active");
  body.classList.toggle("overflow-hidden");

  if (!mobileMenu.classList.contains("d-left")) {
    // On close, get all of the sub-menu's that are visible, close them
    // d-left is applied to mobileMenu while it is closed
    const x = mobileMenu.querySelectorAll(".expandable-mobile-menu");
    x.forEach(
      (item, i) =>
        item.classList.contains("visibled") && item.classList.toggle("visibled")
    );
  }
});

let mobileMenuChevronOpen = () => {
  mobileDropdown.map((dropdown) => {
    const resultdropdown = [];
    const valuesdropdown = dropdown.childNodes;
    Array.prototype.push.apply(resultdropdown, valuesdropdown);
    let anchorElement = dropdown.childNodes[0];
    anchorElement.addEventListener("click", (e) => {
      // let isExpanded = chevron[0].classList.toggle("d-none");
      let targetElement = event.target || event.srcElement;
      // Opening the menu
      let elementToSetVisible = targetElement.parentNode.querySelector(
        ".expandable-mobile-menu"
      );
      if (elementToSetVisible) {
        // If it exists, set animation toggle
        elementToSetVisible.classList.toggle("visibled");
      }
    });
  });
};

let createPagesForSubMenu = () => {
  const tempDropdownMenu = [];
  Array.prototype.push.apply(tempDropdownMenu, dropdownMenu);

  /**
   * This is only used for the last sub-menu (where the last sub-menu doesn't have children, since we are looping sub-menus with children)
   */
  tempDropdownMenu.forEach(
    (item) =>
      item.querySelector(".sub-menu") &&
      tempDropdownMenu.push(item.querySelector(".sub-menu"))
  );

  /**
   * Add the class which denotes each sub-menu has a page of it's own
   * On top of that, let's add a back button to each new page
   */
  tempDropdownMenu.forEach((item, i) => {
    // back button creation
    let p_back = document.createElement("p");
    p_back.classList.add("mobile-menu-back");
    p_back.innerHTML = "back";
    /**
     * This is how we close the page on "back click"
     */
    p_back.addEventListener("click", (e) => {
      let parentOfBackButton = event.target || event.srcElement;
      parentOfBackButton.parentNode.classList.toggle("visibled");
    });
    if (item.classList.contains("sub-menu")) {
      // This is for the last sub-menus with no children in the tree. (the last page)
      item.classList.add("expandable-mobile-menu");
      if (!item.querySelector(".mobile-menu-back")) item.appendChild(p_back);
    } else {
      // This is for the sub-menus with children (not the last page)
      if (i > 0) item.parentNode.classList.add("expandable-mobile-menu");
      if (i > 0 && !item.parentNode.querySelector(".mobile-menu-back"));
      if (i > 0) item.querySelector("a").href = "javascript:void(0)";
      // item.parentNode.appendChild(p_back);
    }
    // And finally, append
    const resultItems = [];
    const valueItems = item.childNodes;
    Array.prototype.push.apply(resultItems, valueItems);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  createPagesForSubMenu();
  mobileMenuChevronOpen();
  mobileIcon.addEventListener("click", mobileIconOpen);
  mobileIconClose.addEventListener("click", mobileIconOpen);
});

// custom sized menu (which scales on text length)
jQuery(document).ready(function ($) {
  let all = jQuery(
    "ul#menu-header .sub-menu .menu-item.menu-item-has-children"
  );
  // let y = $("html").css("--ulsubmenuwidth");
  jQuery(".sub-menu .menu-item.menu-item-has-children").hover(function () {
    let root = document.documentElement;
    // let x = root.style.setProperty("--mainulsubmenu", "471px");
    // let y = root.style.setProperty("--ulsubmenuwidth", 400);
    let zy = $(this).find(".sub-menu").outerWidth();
    let yvc = root.style.setProperty("--ulsubmenuwidth", zy + "px");
    let x = root.style.setProperty("--mainulsubmenu", 301 + zy + "px");
    let z = document.documentElement.style.getPropertyValue("--mainulsubmenu");
  });
  // jQuery(".sub-menu .menu-item:not(.menu-item-has-children)").hover(
  //   function () {
  //     let root = document.documentElement;
  //     // let x = root.style.setProperty("--mainulsubmenu", "471px");
  //     // let y = root.style.setProperty("--ulsubmenuwidth", 400);
  //     let zy = 0;
  //     let yvc = root.style.setProperty("--ulsubmenuwidth", zy + "px");
  //     let x = root.style.setProperty("--mainulsubmenu", 301 + zy + "px");
  //     let z = document.documentElement.style.getPropertyValue(
  //       "--mainulsubmenu"
  //     );
  //   }
  // );
  let root = document.documentElement;
  let zy = all.first().find(".sub-menu").outerWidth();
  let yvc = root.style.setProperty("--ulsubmenuwidth", zy + "px");
  let x = root.style.setProperty("--mainulsubmenu", 301 + zy + "px");
  // all.each(function () {
  //   // $(this).addClass("foo");
  //   // let x = $(this).find("::after");
  //   console.log(zy);
  // });
});
